import { EToasterVariant } from '@enums/toasterVariant.enum';
import SuccessIcon from '@assets/images/toasterSuccessIcon.svg?react';
import ErrorIcon from '@assets/images/toasterErrorIcon.svg?react';

export const baseToasterConfig = {
  [EToasterVariant.SUCCESS]: {
    className: 'success',
    IconComponent: SuccessIcon,
  },
  [EToasterVariant.ERROR]: {
    className: 'error',
    IconComponent: ErrorIcon,
  },
};
